module.exports = __webpack_public_path__ + "static/media/Giving3.09d01f0a.png";